module.exports = __webpack_public_path__ + "7d3f43f0e6bcfe64d585a3569d4898f1.woff2";